import React, { useEffect, useState, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as theme from "../theme";
import Switch from '@material-ui/core/Switch';

import {
  getBrokeragesList,
  loadBrokerages,
  brokerageSelected
} from "../store/brokerages";
import Select from "react-dropdown-select";

const BrokerageSuperAdminPaymentDetails = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(loadBrokerages());
  }, [dispatch]);
  const onChangeHandle = (value) => {
    dispatch(brokerageSelected(value[0].code));
  };
  const brokerages = useSelector(getBrokeragesList);
  return (
    <div>
      <div
        style={{
          width: "100%",
          display: "flex",
        }}
      >
        <div style={{ width: "80%", marginLeft: "10%", marginTop: "20px" }}>
          <Select
            placeholder={"Search for a brokerage"}
            color={theme.COLORS.primary_navyblue}
            searchable={true}
            onChange={(values) => onChangeHandle(values)}
            values={[]}
            options={brokerages}
            style={{
              width: "100%",
              height: "6vh",
              fontSize: "1.9vmin",
              border: "5px solid white",
              borderRadius: 15,
              fontFamily: "GibsonRegular",
            }}
            labelField={"name"}
            valueField={"code"}
            dropdownHeight={"58vh"}
          />
        </div>
      </div>
      <PaymentDetailsPane></PaymentDetailsPane></div>
  );
};

const PaymentDetailsPane = () => {
  return (
    <div
      style={{
        margin: "3.5rem",
        marginTop: "1.5rem",
        marginBottom: "50vh",
        overflow: "hidden",
      }}
    >
      <div>
        <h5 class="px-2" style={{
          fontFamily: "GibsonSemiBd",
          justifyContent: "center",
          fontSize: "1.2vw",
        }}>When ready, you will be able to review payment here, update payment details etc. This is in development and we will get it ready for you soon. Thanks for your patience.</h5>
      </div>
    </div>
  );
};

export default BrokerageSuperAdminPaymentDetails;
